/**
*
* PendingTopics
*
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { pick } from 'lodash-es';
import { Button } from 'react-bootstrap';
import useApi3 from 'utils/useApi3/index.js';
import messages from '../messages.js';
import TopicItem from './TopicItem.jsx';
import PendingList from './PendingList/index.jsx';
import useConversationsContext from '../useConversationsContext.js';

function PendingTopics(props) {
  const { baseUrl, topics, setInTopics } = useConversationsContext();
  const { pendingCount, setEditPost } = props;
  const [show, setShow] = useState(false);

  function setState(updater) {
    setInTopics(['pendingItems'], updater);
  }

  const url = `${baseUrl}/pending?offset=0&limit=20`;
  const loadData = useApi3({ url, skipLoading: true }, setState);

  function handleOpen() {
    loadData();
    setShow(true);
  }

  function handleClick(item) {
    const pendingItem = { ...item, ...pick(item.latestMessage, ['body', 'media']) };
    setEditPost(pendingItem);
    setShow(false);
  }
  const renderItem = (item) => <TopicItem key={item.id} topic={item} onClick={() => handleClick(item)} />;

  return (
    <>
      {pendingCount > 0 && (
        <Button variant="link" onClick={handleOpen}>
          <FormattedMessage {...messages.pending} values={{ pendingCount }} />
        </Button>
      )}
      {show && <PendingList onHide={() => setShow(false)} items={topics.pendingItems} renderItem={renderItem} />}
    </>
  );
}

PendingTopics.propTypes = {
  pendingCount: PropTypes.number,
  setEditPost: PropTypes.func,
};

export default PendingTopics;
